"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3996],{

/***/ 41926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sT": function() { return /* reexport */ BigPlayButton; },
  "Y9": function() { return /* reexport */ Cover; },
  "ZP": function() { return /* reexport */ VideoPlayer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 1 modules
var v4 = __webpack_require__(20982);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
;// CONCATENATED MODULE: ../../libs/matcha/components/VideoPlayer/VideoPlayer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





var hoverOutlinedSvg = function hoverOutlinedSvg(color) {
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)("&:hover{.circle{fill:", color, ";stroke:", color, ";}.triangle{fill:", (0,polished_esm/* transparentize */.DZ)(1, color), ";}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
};

var outlinedSvg = function outlinedSvg(color) {
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(".circle{transition:all 0.3s;fill:", (0,polished_esm/* transparentize */.DZ)(1, color), ";stroke:", color, ";}.triangle{transition:all 0.3s;fill:", color, ";}", hoverOutlinedSvg(color), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
};

var filledSvg = function filledSvg(color, backgroundColor) {
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(".circle{transition:all 0.3s;fill:", color, ";stroke:", color, ";}.triangle{transition:all 0.3s;fill:", backgroundColor, ";}&:hover{.circle{fill:", backgroundColor, ";stroke:", backgroundColor, ";}.triangle{fill:", color, ";}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
};

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ech1t9r5"
} : 0)("position:absolute;z-index:2;box-sizing:content-box;width:70px;height:70px;top:calc(50% - 35px);left:calc(50% - 35px);", function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return variant !== "text" && theme.breakpoints.up("sm");
}, "{width:120px;height:120px;top:calc(50% - 60px);left:calc(50% - 60px);}", function (_ref4) {
  var variant = _ref4.variant,
      color = _ref4.color;
  return variant === "text" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("width:216px;height:60px;top:calc(50% - 35px);left:calc(50% - 108px);", hoverOutlinedSvg(color), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref2 =  true ? {
  name: "1a3dkxu",
  styles: "display:grid;grid-template-columns:70px 1fr;column-gap:18px"
} : 0;

var Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.button,  true ? {
  target: "ech1t9r4"
} : 0)("position:relative;overflow:visible;cursor:pointer;", function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant !== "text" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("width:70px;height:70px;", theme.breakpoints.up("sm"), "{width:120px;height:120px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var variant = _ref6.variant;
  return variant === "text" && _ref2;
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "p92u9l",
  styles: "width:70px;height:70px"
} : 0;

var PlayIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.svg,  true ? {
  target: "ech1t9r3"
} : 0)(function (_ref7) {
  var variant = _ref7.variant,
      color = _ref7.color,
      backgroundColor = _ref7.backgroundColor;
  return variant === "filled" && filledSvg(color, backgroundColor);
}, " ", function (_ref8) {
  var variant = _ref8.variant,
      color = _ref8.color;
  return variant !== "filled" && outlinedSvg(color);
}, " ", function (_ref9) {
  var variant = _ref9.variant;
  return variant === "text" && _ref;
}, ";" + ( true ? "" : 0));
var ButtonLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ech1t9r2"
} : 0)("cursor:pointer;font-family:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.pSmall.fontFamily;
}, ";color:", function (_ref11) {
  var color = _ref11.color;
  return color;
}, ";text-decoration:underline;margin:auto;" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ech1t9r1"
} : 0)("position:relative;overflow:hidden;width:100%;padding-top:56.25%;border-radius:20px;display:flex;mask-image:-webkit-radial-gradient(\n    ", function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.neutrals.white[100];
}, ",\n    ", function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.neutrals.black[100];
}, "\n  );" + ( true ? "" : 0));
var VideoPlayer_views_Cover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ech1t9r0"
} : 0)("position:absolute;top:0;left:0;width:100%;height:100%;background-color:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.neutrals.white[100];
}, ";z-index:1;" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/VideoPlayer/VideoPlayer.tsx


var _excluded = ["children", "className", "controls", "url"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var ReactPlayer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7959).then(__webpack_require__.bind(__webpack_require__, 37959));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37959)];
    }
  }
});
var VideoPlayer = function VideoPlayer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? true : _ref$controls,
      originalUrl = _ref.url,
      reactPlayerProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var url = originalUrl.includes("fast.wistia.com") ? originalUrl.replace("/medias", "/iframe") : originalUrl;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
      children: children
    }, (0,v4/* default */.Z)()), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReactPlayer, _objectSpread({
      width: "100%",
      height: "100%",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      },
      controls: controls,
      url: url
    }, reactPlayerProps))]
  });
};
var buttonVariants = {
  initial: {
    opacity: 0,
    transition: {
      delay: 0.3
    }
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3
    }
  }
};

var BaseBigPlayButton = function BaseBigPlayButton(_ref2) {
  var onClick = _ref2.onClick,
      _ref2$ariaLabel = _ref2.ariaLabel,
      ariaLabel = _ref2$ariaLabel === void 0 ? "Watch the video" : _ref2$ariaLabel,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "filled" : _ref2$variant,
      tokens = _ref2.tokens,
      _ref2$maskId = _ref2.maskId,
      maskId = _ref2$maskId === void 0 ? "cut-off-play" : _ref2$maskId;
  var label = variant === "text" && ariaLabel;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, _objectSpread(_objectSpread({
    variant: variant
  }, tokens), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button, _objectSpread(_objectSpread({
      "aria-label": ariaLabel,
      onClick: onClick,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      variant: variant,
      variants: buttonVariants
    }, tokens), {}, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlayIcon, _objectSpread(_objectSpread({
        viewBox: "0 0 150 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        animate: "animate",
        variant: variant,
        variants: buttonVariants
      }, tokens), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("mask", {
            id: maskId,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
              x: "0",
              y: "0",
              width: "150",
              height: "150",
              rx: "75",
              stroke: "current",
              fill: "white"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              transform: "translate(56, 43)",
              d: "M52 30L0 60L2.62462e-06 0L52 30Z",
              fill: "black"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
          className: "circle",
          x: "3",
          y: "3",
          width: "144",
          height: "144",
          rx: "72",
          fill: "current",
          stroke: "current",
          strokeWidth: "6",
          mask: "url(#".concat(maskId, ")")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          className: "triangle",
          transform: "translate(56, 43)",
          d: "M52 30L0 60L2.62462e-06 0L52 30Z",
          fill: "current"
        })]
      })), label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonLabel, _objectSpread(_objectSpread({}, tokens), {}, {
        children: label
      }))]
    }))
  }));
};

var coverVariants = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.3
    },
    transitionEnd: {
      zIndex: -1
    }
  },
  show: {
    opacity: 1,
    zIndex: 1
  }
};
var Cover = function Cover(_ref3) {
  var children = _ref3.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer_views_Cover, _objectSpread(_objectSpread({
    initial: "hidden",
    animate: "show",
    exit: "hidden",
    variants: coverVariants
  }, rest), {}, {
    children: children
  }));
};
var BigPlayButton = (0,useDesignTokens/* withDesignTokens */.Y)(BaseBigPlayButton, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.blue[60]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.blue[60]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/VideoPlayer/index.ts

VideoPlayer.displayName = "VideoPlayerBase";
Cover.displayName = "VideoPlayer.Cover";
BigPlayButton.displayName = "VideoPlayer.BigPlayButton";


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ })

}]);